/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type */ 
export const StyledTextAreaTypes = {
    primary: "primary" as const,
    primaryBasic: "primary-basic" as const,
    primaryStatic: "primary-static" as const
};

export type StyledTextAreaTypes = typeof StyledTextAreaTypes[keyof typeof StyledTextAreaTypes];
